import * as Sentry from '@sentry/react';

const devHosts = ['localhost', '127.0.0.1', 'latest.test'];

const sentryEnvironment = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production';

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://7e59deb4e8a7804dcd30285d30c7a124@o4509057753153536.ingest.de.sentry.io/4509146604830800',

        enabled: !devHosts.includes(window.location.hostname),
        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        enableLogs: true,
        environment: sentryEnvironment,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions
        // Session Replay
        replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
} else {
    console.warn('Sentry is disabled in development mode.');
}

/**
 * Start a new transaction with the given name and set user context
 */
export function startTransaction(transactionName, userEmail = null) {
    const transaction = Sentry.startInactiveSpan({
        name: transactionName,
        op: 'checkout.transaction',
    });

    if (userEmail) {
        Sentry.setUser({ email: userEmail });
    }

    Sentry.setTag('transaction_uuid', transactionName);

    return transaction;
}

/**
 * Create a span within the current transaction
 */
export function createSpan(operation, description) {
    return Sentry.startInactiveSpan({
        op: operation,
        name: description,
    });
}

/**
 * Set transaction context with UUID and user info
 */
export function setTransactionContext(transactionUuid, userEmail) {
    Sentry.setUser({ email: userEmail });
    Sentry.setTag('transaction_uuid', transactionUuid);
    Sentry.setContext('transaction', {
        uuid: transactionUuid,
    });
}

export { Sentry };
